export const site = {
  name: "Agentic Plus",
  url: "https://agenticplus.dev",
  email: "hello@agenticplus.dev",
  description:
    "Agentic Plus organizes evidence, brand knowledge, creative production, approvals, and learning into trackable growth missions.",
  founded: "2026",
  lastReviewed: "2026-10-13",
} as const;

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: site.name,
  url: site.url,
  email: site.email,
  logo: `${site.url}/og-image.png`,
  description: site.description,
};
